import { useMemo } from "react"

import type { Token } from "@/domains/core"

import { useChainConfig } from "./use-chain-config"

export const useNativeToken = () => {
  const chainConfig = useChainConfig()

  const nativeToken = useMemo(() => {
    return chainConfig.tokens.native as Token
  }, [chainConfig])

  return nativeToken
}
